import { booleanAttribute, Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[cslLabel]',
  standalone: true,
})
export class LabelDirective {
  @Input({ transform: booleanAttribute }) disabled?: boolean;
  @Input({ transform: booleanAttribute }) required?: boolean;

  @HostBinding('class') get styles(): string {
    const group = 'group-[.g-control-invalid]:after:text-[--input-label-invalid-asterisk-color]';
    const base = 'text-sm font-medium';
    const addStyles = 'text-[--input-label-color]';
    const disabledStyles = 'text-[--input-label-disabled-color]';
    const requiredStyles = `after:content-['*'/''] after:text-[--input-label-asterisk-color] after:ml-0.5`;

    return `${group} ${base} ${this.disabled ? disabledStyles : addStyles} ${this.required && requiredStyles}`;
  }
}
